export default {
  props: {
    type: String,
    text: String,
    url: String,
  },
  computed: {
    isLink() {
      return this.type === 'link';
    },
    isButton() {
      return this.type === 'button';
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/generics/link/link.js